import PropTypes from "prop-types";
import { useState } from "react";
import { ButtonGroup, ButtonToolbar, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import CloseButton from 'react-bootstrap/CloseButton';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Cookies } from "react-cookie";
import { FormattedMessage } from "react-intl";
import { COOKIE_BANNER_CLOSED} from "../../common/constant";
import HeaderContainer from "../app/HeaderContainer";
import VisibleContainer from "./VisibleContainer";

const StandardView = ({ children, titleKey, title, actions, id }) => {
  const cookies = new Cookies();
  //const bannerClosedFromCookie = Boolean(cookies.get(COOKIE_BANNER_CLOSED));
  const [isBannerClosed, setIsBannerClosed] = useState(true); //Banner disabled -> to active again the banner set bannerClosedFromCookie as initial value

  function closeBanner() {
    setIsBannerClosed(true);
    cookies.set(COOKIE_BANNER_CLOSED, true, {path: "/", maxAge: 86400});
  }

  return (
  <>
    <HeaderContainer page={id} />
    <Container fluid id={id} className="px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 my-4">
      <Row className="mb-4">
        <Col>
          <h2>{title || <FormattedMessage id={titleKey} />}</h2>
        </Col>
        {actions && (
          <Col className="d-flex justify-content-end align-items-start">
            <ButtonToolbar>
              <ButtonGroup className="gap-2">
                {actions
                  .filter((a) => !!a && !a.hide)
                  .map((action, index) => (
                    <VisibleContainer key={index} roles={action.roles || []}>
                      {action.component || (
                        <Button onClick={action.onClick} variant={action.variant}>
                          {action.icon}
                          <FormattedMessage id={action.labelKey} />
                        </Button>
                      )}
                    </VisibleContainer>
                  ))}
              </ButtonGroup>
            </ButtonToolbar>
          </Col>
        )}
      </Row>
      <Row>
        <Col>{children}</Col>
      </Row>
    </Container>

    {!isBannerClosed && (
      <div className="bg-warning p-2 text-center fw-bold rounded position-fixed w-100 fixed-bottom">
        <CloseButton onClick={closeBanner} className="position-absolute top-0 end-0 m-2" />
        <FormattedMessage
          id="app.footer.banner.info"
          values={{
            link: content =>
              (<a href="https://static.daad.de/media/daad_de/pdfs_nicht_barrierefrei/der-daad/wer-wir-sind/2024_07_handbuch_tool_hochschulen_v2.1.pdf" className="text-decoration-none" target='_blank' rel="noopener noreferrer">{content}</a>),
            br: () => (<br />)
          }}
        />
      </div>
    )}
  </>
)}

StandardView.propTypes = {
  id: PropTypes.string.isRequired,
  titleKey: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.any),
  intl: PropTypes.object,
  children: PropTypes.node
};

export default StandardView;
